// extracted by mini-css-extract-plugin
export var cardIcon = "_9f-5";
export var cardIconUnframed = "_9f-9";
export var checkboxCard = "_9f-0";
export var checkboxCardSelected = "_9f-4";
export var disabled = "_9f-2";
export var interactive = "_9f-1";
export var outerBorder = "_9f-3";
export var spacerMedium = "_9f-8";
export var spacerSmall = "_9f-7";
export var spacerXsmall = "_9f-6";